<div class="scan-btn__wrapper">
    <button
        priva-button
        [iconState]="iconState()"
        [iconClass]="iconClass()"
        [class.scan-btn--not-clickable]="!isClickable()"
        class="scan-btn"
        importance="secondary"
        size="md"
        #scanBtn
        density="md"
        (click)="onClick()"
    >
        {{ text() }}
    </button>
</div>
